import { Button } from "@/components/ui/button";
import { HeroQuickForm } from "@/components/HeroQuickForm";
import heroImage from "@/assets/hero-pool-3.jpeg";
import heroImageWebp from "@/assets/hero-pool-3.webp";
export const Hero = () => {
  return <section className="relative min-h-screen pt-20 flex items-center justify-center">
      {/* Optimized hero image for LCP */}
      <picture className="absolute inset-0 w-full h-full">
        <source srcSet={heroImageWebp} type="image/webp" />
        <img 
          src={heroImage} 
          alt="Premium luxury swimming pool with pristine crystal clear water in San Diego estate" 
          className="w-full h-full object-cover" 
          {...({ fetchpriority: "high" } as any)}
          decoding="async"
          width="1920"
          height="1080"
        />
      </picture>
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/50 z-10"></div>
      
      {/* Content */}
      <div className="relative z-20 container mx-auto px-4 text-center text-white">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            Elevate Your Pool Experience with{" "}
            <span className="text-[#3399ff]">BlueLux</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-white/90 max-w-3xl mx-auto">
            Premium pool maintenance services for discerning homeowners in San Diego's finest communities
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button size="lg" className="bg-gold hover:bg-gold/90 text-gold-foreground font-semibold px-8 py-4 text-lg" onClick={() => document.getElementById("contact")?.scrollIntoView({
            behavior: "smooth"
          })}>
              Get a Free Quote
            </Button>
            <Button size="lg" variant="outline" className="border-white text-white hover:bg-white hover:text-primary font-semibold px-8 py-4 text-lg" onClick={() => document.getElementById("services")?.scrollIntoView({
            behavior: "smooth"
          })}>
              View Services
            </Button>
          </div>

          {/* Quick Quote Form */}
          <HeroQuickForm />
        </div>
      </div>
    </section>;
};